import { LocalStorage } from '../../../shared/utils';
import { showPublishUnmappedFieldsDialogComponent } from '../PublishUnmappedFieldsDialog';

export const PUBLISH_UNMAPPED_FIELDS_SKIP_KEY = 'picsio.publishUnmappedFieldsDontShow';

export function showPublishUnmappedFieldsDialog({
  channelsWithUnmapped,
  fullyMappedCount,
  totalChannelCount,
}) {
  return showPublishUnmappedFieldsDialogComponent({
    channelsWithUnmapped,
    fullyMappedCount,
    totalChannelCount,
  }).then((dontShowAgain) => {
    if (dontShowAgain) {
      LocalStorage.set(PUBLISH_UNMAPPED_FIELDS_SKIP_KEY, true);
    }
  });
}

export default showPublishUnmappedFieldsDialog;
